var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 181,
    viewBox: "0 0 272 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6434_876)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.6396 132.507C33.108 107.044 40.7283 93.6044 45.3548 88.4355C56.3125 76.1932 71.4812 83.1307 111.079 52.525C144.624 26.5978 165.315 -1.75771 206.604 37.4262C271.103 98.6374 206.604 166.786 170.68 156.176C138.604 146.702 125.503 148.014 116.794 152.095C73.5224 171.683 47.8041 164.337 39.6396 132.507Z",
    fill: "#ECF3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.563 90.1971C237.026 93.9363 227.021 89.1286 227.021 89.1286C227.021 89.1286 229.245 78.2608 236.786 74.5267C244.324 70.7876 254.324 75.5901 254.324 75.5901C254.324 75.5901 252.101 86.458 244.563 90.1971Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.972 41.4493C171.415 41.4493 169.342 43.5223 169.342 46.0796C169.342 48.6368 171.415 50.7098 173.972 50.7098C176.53 50.7098 178.603 48.6368 178.603 46.0796C178.603 43.5223 176.53 41.4493 173.972 41.4493Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0976 58.4256C41.9668 58.4256 40.2393 56.6982 40.2393 54.5673C40.2393 52.4364 41.9668 50.709 44.0976 50.709C46.2285 50.709 47.956 52.4364 47.956 54.5673C47.956 56.6982 46.2285 58.4256 44.0976 58.4256Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.835 76.4317C193.841 76.4317 193.034 75.6256 193.034 74.6311C193.034 73.6366 193.841 72.8304 194.835 72.8304C195.83 72.8304 196.636 73.6366 196.636 74.6311C196.636 75.6256 195.83 76.4317 194.835 76.4317Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.227 157.292C203.948 157.292 202.912 156.255 202.912 154.977C202.912 153.698 203.948 152.662 205.227 152.662C206.505 152.662 207.542 153.698 207.542 154.977C207.542 156.255 206.505 157.292 205.227 157.292Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4077 134.282C41.5609 134.282 40.0638 132.785 40.0638 130.938C40.0638 129.091 41.5609 127.594 43.4077 127.594C45.2546 127.594 46.7517 129.091 46.7517 130.938C46.7517 132.785 45.2546 134.282 43.4077 134.282Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1671 53.7715C93.7614 53.7715 92.6219 52.632 92.6219 51.2263C92.6219 49.8207 93.7614 48.6812 95.1671 48.6812C96.5727 48.6812 97.7122 49.8207 97.7122 51.2263C97.7122 52.632 96.5727 53.7715 95.1671 53.7715Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.078 42.0777C216.515 42.0777 215.249 40.8109 215.249 39.2481C215.249 37.6853 216.515 36.4185 218.078 36.4185C219.641 36.4185 220.908 37.6853 220.908 39.2481C220.908 40.8109 219.641 42.0777 218.078 42.0777Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7716 35.4141C61.1348 36.7696 60.3304 38.1629 58.9749 38.5261C57.6194 38.8893 56.2261 38.0849 55.8629 36.7294C55.4997 35.3739 56.3041 33.9806 57.6596 33.6174C59.0151 33.2542 60.4084 34.0586 60.7716 35.4141Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.615 31.2307C122.748 31.2307 121.235 29.7173 121.235 27.8505C121.235 25.9837 122.748 24.4703 124.615 24.4703C126.482 24.4703 127.995 25.9837 127.995 27.8505C127.995 29.7173 126.482 31.2307 124.615 31.2307Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.388 112.628C221.952 112.628 220.788 111.697 220.788 110.548C220.788 109.399 221.952 108.468 223.388 108.468C224.824 108.468 225.988 109.399 225.988 110.548C225.988 111.697 224.824 112.628 223.388 112.628Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.452 19.5163C206.208 22.3374 204.534 25.2371 201.713 25.993C198.892 26.7489 195.992 25.0747 195.236 22.2537C194.48 19.4326 196.154 16.5328 198.976 15.7769C201.797 15.021 204.696 16.6952 205.452 19.5163Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.894 133.262H219.962C220.365 138.969 224.609 139.057 224.609 139.057C224.609 139.057 219.929 139.149 219.929 145.743C219.929 139.149 215.249 139.057 215.249 139.057C215.249 139.057 219.491 138.969 219.894 133.262ZM72.146 151.665H72.2063C72.5635 156.83 76.3298 156.91 76.3298 156.91C76.3298 156.91 72.1768 156.993 72.1768 162.961C72.1768 156.993 68.0237 156.91 68.0237 156.91C68.0237 156.91 71.7885 156.83 72.146 151.665Z",
    fill: "#E8EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.012 168.477C179.078 168.477 213.99 133.565 213.99 90.4994C213.99 47.4338 179.078 12.5222 136.012 12.5222C92.9468 12.5222 58.0352 47.4338 58.0352 90.4994C58.0352 133.565 92.9468 168.477 136.012 168.477Z",
    stroke: "#B3CFE2",
    strokeWidth: 1.49928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0274 148.723L87.988 85.3572C88.4161 78.5076 94.0962 73.1714 100.959 73.1714H171.066C177.928 73.1714 183.608 78.5076 184.036 85.3569L187.997 148.723M158.538 73.1687V69.9447C158.538 57.5034 148.453 47.4181 136.012 47.4181C123.571 47.4181 113.485 57.5034 113.485 69.9447V73.1687",
    stroke: "#B3CFE2",
    strokeWidth: 1.49928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.357 75.1971C216.756 75.1971 227.619 64.3343 227.619 50.9344C227.619 37.5344 216.756 26.6716 203.357 26.6716C189.957 26.6716 179.094 37.5344 179.094 50.9344C179.094 64.3343 189.957 75.1971 203.357 75.1971Z",
    fill: "#85DFA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.918 46.2399L201.158 57.1982L194.698 50.6243",
    stroke: "white",
    strokeWidth: 4.05138,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.472 112.571C144.785 112.571 140.198 117.359 140.198 123.245V135.057H132.008V123.245C132.008 117.359 127.383 112.61 121.695 112.571H112.823V119.713H121.733C123.591 119.713 125.108 121.283 125.108 123.206V142.199H147.098V123.206C147.098 121.283 148.615 119.713 150.472 119.713H159.382V112.571H150.472Z",
    fill: "#679FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.95 125.271H112.823V142.202H119.878V127.235C119.878 126.135 119.03 125.271 117.95 125.271Z",
    fill: "#679FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.153 107.697H129.267C131.128 107.697 132.647 109.252 132.647 111.157H139.559C139.559 109.252 141.078 107.697 142.939 107.697H149.053C154.749 107.697 159.344 102.953 159.382 97.1207V91.405H152.471V97.1207C152.471 99.026 150.952 100.581 149.091 100.581H142.939C140.432 100.581 137.964 101.553 136.103 103.264C134.242 101.553 131.774 100.581 129.267 100.581H123.153C121.292 100.581 119.773 99.026 119.773 97.1207V91.405H112.823V97.1207C112.861 102.953 117.457 107.658 123.153 107.697Z",
    fill: "#679FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.328 127.235V142.202H159.382V125.271H154.255C153.215 125.271 152.328 126.135 152.328 127.235Z",
    fill: "#679FC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6434_876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 271.5,
    height: 181,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSuccess);
export default __webpack_public_path__ + "static/media/CartSuccess.82f82ad22923bb277303204c37c225a4.svg";
export { ForwardRef as ReactComponent };